import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  border-radius: 100px 100px 100px 100px;
  border: transparent;
  box-shadow: 0 0 5px var(--gray-300);
  width: 100%;
  transition: transform 300ms;
  background-color: var(--gray-800);
  padding: 1rem;

  @media (max-width: 321px) {
    padding-left: 0;
    padding-right: 0;
  }

  &:hover {
    transform: scale(1.05);
    z-index: 1;
  }
`;

export const Title = styled.span`
  font-weight: bold;
  font-size: 1rem;

  @media (max-width: 321px) {
    font-size: 0.7rem;
  }

  @media (max-width: 376px) {
    font-size: 0.8rem;
  }
`;

export const LinkCard = styled(Link)`
  text-decoration: none;
  color: var(--gray-300);

  :hover {
    text-decoration: none;
    color: var(--gray-300);
  }
`;
